import { IColumn } from 'shared/interface';

export const API_BASE_URL = process.env['REACT_APP_BASE_URL'];
export const ENCRYPTION_KEY = process.env['REACT_APP_ENCRYPTION_KEY'];
export const EDITOR_KEY = process.env['REACT_APP_LICENSE_KEY'];

export const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/;

export const USER_EMAIL = 'admin@gmail.com';
export const USER_PASSWORD = 'Password@123';

export const MOCK_API_MODULES = {
	LOGIN: 'LOGIN',
	FORGOT_PASSWORD: 'FORGOT_PASSWORD',
	RESET_PASSWORD: 'RESET_PASSWORD',
	MASTER: 'MASTER',
	VERIFY_ACCOUNT: 'VERIFY_ACCOUNT',
	USER: 'USER',
	NOTIFICATION: 'NOTIFICATION',
	CHANGE_PASSWORD: 'CHANGE_PASSWORD',
	INDUSTRY_SALES: 'INDUSTRY_SALES',
	MY_PROFILE: 'MY_PROFILE',
	MY_SALES: 'MY_SALES'
};

export const ROUTES = {
	// auth routes
	LOGIN: '/login',
	FORGOT_PASSWORD: '/forgot-password',
	RESET_PASSWORD: '/reset-password/:token',
	VERIFY_ACCOUNT: '/verify-account/:token/:userId',
	// public routes
	DASHBOARD: '/dashboard',
	MY_PROFILE: '/my-profile',
	CHANGE_PASSWORD: '/change-password',
	// permission routes
	USER: '/user',
	ADD_USER: '/user/add',
	EDIT_USER: '/user/edit',
	MASTER: '/master',
	ADD_MASTER: '/master/add',
	EDIT_MASTER: '/master/edit',
	MAPPING: '/mapping',
	MAPPING_HISTORY_LOG: '/mapping/history-log',
	MAPPING_MARKETS: '/mapping/markets',
	MY_SALES: '/my-sales',
	ADD_MY_SALES: '/my-sales/add',
	EDIT_MY_SALES: '/my-sales/edit',
	INDUSTRY_SALES: '/industry-sales',
	SUBMISSION_SUMMARY: '/industry-sales/submission-summary',
	SALES_CREATE_CHANGE_LOG: '/change-log/sales/create',
	SALES_UPDATE_CHANGE_LOG: '/change-log/sales/update',
	MASTER_CREATE_CHANGE_LOG: '/change-log/master/create',
	MASTER_UPDATE_CHANGE_LOG: '/change-log/master/update',
	MASTER_DELETE_CHANGE_LOG: '/change-log/master/delete',
	MASTER_HISTORY_LOG: '/master/history-log',
	MY_SALES_HISTORY_LOG: '/my-sales/history-log',
	ACCESS_DENIED: '/access-denied',
	NEWS_ROOM: '/news-room',
	ADD_NEWS: '/news-room/add',
	EDIT_NEWS: '/news-room/edit',
	VIEW_NEWS: '/news-room/view',
	DETAIL_VIEW: '/dashboard',
	VOTING: '/poll',
	ADD_VOTING: '/poll/add',
	VOTING_DETAILS: '/poll/details'
};

export const MODULE = {
	DASHBOARD: 'dashboard',
	USER: 'user',
	MASTER: 'master',
	MAPPING: 'mapping',
	MY_SALES: 'my-sales',
	INDUSTRY_SALES: 'industry-sales',
	NEWS_ROOM: 'news',
	VOTING: 'voting'
};

export const PERMISSION = {
	LIST: 'list',
	ADD: 'add',
	EDIT: 'edit',
	UPLOAD: 'upload',
	DELETE: 'delete',
	HISTORY: 'history'
};

export const RECORDS_PER_PAGE_OPTIONS = [
	{ label: 10, value: 10 },
	{ label: 30, value: 30 },
	{ label: 50, value: 50 },
	{ label: 100, value: 100 }
];

export const USER_ROLE_OPTIONS = [
	{ label: 'Admin', value: '2' },
	{ label: 'Sales', value: '3' },
	{ label: 'Master', value: '4' }
];

export const DEFAULT_PARAMS = {
	current_page: 1,
	record_per_page: 10
};

export const MAX_FILE_SIZE = 1 * 1024 * 1024; // 1MB

export const ALLOW_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

export enum S3BucketResource {
	PROFILE_PICTURE_FOLDER = 'PROFILE_PICTURE_FOLDER',
	NEWS = 'news',
	POLLS = 'polls'
}

export const INITIAL_MODAL_STATE = {
	open: false,
	type: ''
};

export const STATUS_FILTER_OPTION = [
	{ label: 'Active', value: 'true' },
	{ label: 'Inactive', value: 'false' }
];

export const UNREQUIRED_OPTION = [
	{
		label: '-',
		value: '-'
	}
];

export const SEGMENT_OPTION = [
	{
		label: 'Bus',
		value: 'Bus'
	},
	{
		label: 'Car',
		value: 'Car'
	},
	{
		label: 'MPV',
		value: 'MPV'
	},
	{
		label: 'Pickup',
		value: 'Pickup'
	},
	{
		label: 'Sports/Speciality',
		value: 'Sports/Speciality'
	},
	{
		label: 'SUV',
		value: 'SUV'
	},
	{
		label: 'Truck',
		value: 'Truck'
	},
	{
		label: 'Van',
		value: 'Van'
	}
];

export const SUB_SEGMENT_OPTION = [
	{
		label: 'A',
		value: 'A'
	},
	{
		label: 'B',
		value: 'B'
	},
	{
		label: 'C',
		value: 'C'
	},
	{
		label: 'D',
		value: 'D'
	},
	{
		label: 'E',
		value: 'E'
	},
	{
		label: 'F',
		value: 'F'
	},
	{
		label: 'G',
		value: 'G'
	},
	{
		label: 'Hvan',
		value: 'Hvan'
	},
	{
		label: 'LD',
		value: 'LD'
	},
	{
		label: 'MD',
		value: 'MD'
	},
	{
		label: 'HD',
		value: 'HD'
	}
];

export const FUEL_TYPE_OPTION = [
	{
		label: 'BEV',
		value: 'BEV'
	},
	{
		label: 'FCEV',
		value: 'FCEV'
	},
	{
		label: 'HEV',
		value: 'HEV'
	},
	{
		label: 'ICE-Diesel',
		value: 'ICE-Diesel'
	},
	{
		label: 'ICE-Petrol',
		value: 'ICE-Petrol'
	},
	{
		label: 'PHEV',
		value: 'PHEV'
	}
];

export const DATA_STATUS_OPTION = [
	{
		label: 'Available',
		value: 'Available'
	},
	{
		label: 'Unavailable',
		value: 'Unavailable'
	}
];

export const FILTER_FIELDS = ['manufacturer', 'brand', 'model', 'fuel_type', 'segment', 'sub_segment'];
export const EXCEL_FIELDS = [
	'Year',
	'Month',
	'Manufacturer',
	'Brand',
	'Model',
	'Fuel Type',
	'Segment',
	'Sub Segment',
	'Saudi Arabia',
	'Oman',
	'Kuwait',
	'UAE',
	'Bahrain',
	'Qatar',
	'Jordan',
	'Lebanon',
	'Syria',
	'Yemen',
	'Iraq'
];

export const MAX_FILE_SIZE_MESSAGE = 'File size exceeds the maximum allowed size of 1MB';
export const INVALID_IMAGE_TYPE_MESSAGE =
	'Invalid file. Please upload a file with one of the following extensions: .jpeg, .jpg, .png, .webp';

export const HISTORY_COLUMN: IColumn[] = [
	{
		id: 'title',
		label: 'Title',
		width: '33%'
	},
	{
		id: 'old_value',
		label: 'Old Data',
		width: '33%'
	},
	{
		id: 'new_value',
		label: 'New Data',
		width: '33%'
	}
];

export const FILTERED_KEY_IGNORE = ['current_page', 'record_per_page', 'sort_by', 'order_by'];
export const MY_SALES_FILTERED_KEY_IGNORE = ['current_page', 'record_per_page', 'sort_by', 'order_by', 'company'];
export const SUBMISSION_SUMMARY_FILTERED_KEY_IGNORE = ['sales_year', 'sales_month', 'sort_by', 'order_by'];
export const DASHBOARD_NEWS_FILTERED_KEY_IGNORE = ['current_page', 'record_per_page', 'sort_by', 'order_by', 'status'];

export const MASTER_COLUMNS: IColumn[] = [
	{
		id: 'manufacturer',
		label: 'Manufacturer',
		sortable: true,
		width: '20%'
	},
	{
		id: 'brand',
		label: 'Brand',
		sortable: true,
		width: '15%'
	},
	{
		id: 'model',
		label: 'Model',
		sortable: true,
		width: '15%'
	},
	{
		id: 'fuel_type',
		label: 'Fuel Type',
		sortable: true,
		width: '10%'
	},
	{
		id: 'segment',
		label: 'Segment',
		sortable: true,
		width: '10%'
	},
	{
		id: 'sub_segment',
		label: 'Sub-segment',
		sortable: true,
		width: '10%'
	}
];

export const COUNTRY_COLUMNS: IColumn[] = [
	{
		id: 'saudi_arabia',
		label: 'Saudi Arabia',
		sortable: true,
		width: '10%'
	},
	{
		id: 'oman',
		label: 'Oman',
		sortable: true,
		width: '3%'
	},
	{
		id: 'kuwait',
		label: 'Kuwait',
		sortable: true,
		width: '3%'
	},
	{
		id: 'uae',
		label: 'UAE',
		sortable: true,
		width: '3%'
	},
	{
		id: 'bahrain',
		label: 'Bahrain',
		sortable: true,
		width: '3%'
	},
	{
		id: 'qatar',
		label: 'Qatar',
		sortable: true,
		width: '3%'
	},
	{
		id: 'jordan',
		label: 'Jordan',
		sortable: true,
		width: '3%'
	},
	{
		id: 'lebanon',
		label: 'Lebanon',
		sortable: true,
		width: '3%'
	},
	{
		id: 'syria',
		label: 'Syria',
		sortable: true,
		width: '3%'
	},
	{
		id: 'yemen',
		label: 'Yemen',
		sortable: true,
		width: '3%'
	},
	{
		id: 'iraq',
		label: 'Iraq',
		sortable: true,
		width: '3%'
	}
];

export const Country = [
	{ value: 'Saudi Arabia', label: 'Saudi Arabia' },
	{ value: 'Oman', label: 'Oman' },
	{ value: 'Kuwait', label: 'Kuwait' },
	{ value: 'UAE', label: 'UAE' },
	{ value: 'Bahrain', label: 'Bahrain' },
	{ value: 'Qatar', label: 'Qatar' },
	{ value: 'Jordan', label: 'Jordan' },
	{ value: 'Lebanon', label: 'Lebanon' },
	{ value: 'Syria', label: 'Syria' },
	{ value: 'Yemen', label: 'Yemen' },
	{ value: 'Iraq', label: 'Iraq' }
];

export const NewsCategory = [
	{ value: 'industry_news', label: 'Industry news' },
	{ value: 'new_launches', label: 'New launches' },
	{ value: 'technology', label: 'Technology' },
	{ value: 'market_trends', label: 'Market trends' },
	{ value: 'regulations', label: 'Regulations' },
	{ value: 'electric_vehicles', label: 'Electric vehicles' },
	{ value: 'manufacturing', label: 'Manufacturing' },
	{ value: 'sales_reports', label: 'Sales reports' },
	{ value: 'partnerships', label: 'Partnerships' },
	{ value: 'sustainability', label: 'Sustainability' }
];

export const INTERACTION_TYPES = {
	VIEW: 'view',
	LIKE: 'like',
	DISLIKE: 'dislike'
} as const;

export type InteractionType = (typeof INTERACTION_TYPES)[keyof typeof INTERACTION_TYPES];

// List of unwanted elements injected by browser extensions
export const UNWANTED_SELECTORS = [
	'grammarly-extension-vbars', // Grammarly extension element
	"div[jsname='rwEEsd']", // Google Translate popup
	'.languagetool-popup', // LanguageTool extension popup
	'.chatgpt-overlay', // ChatGPT overlay
	'.ad-inserted', // Any dynamically inserted ads
	'#gtx-trans' // Google Translate injected element
];

export const DASHBOARD_TABS = {
	Dashboard: 'Dashboard',
	AMBG_Dashboard: 'AMBG Dashboard',
	News_Room: 'News Room',
	MG_Dashboard: 'MG Dashboard'
};

export const NEWS_STATUS = {
	published: 'Publish',
	draft: 'Draft'
};

export const POLL_STATUS_COLORS: Record<string, string> = {
	Ongoing: '#34C759',
	Live: '#34C759',
	Upcoming: '#4A8BCB',
	Ended: '#D3202D'
};
